"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var text_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/text_input"));
var DEFAULT_MAX_LENGTH = 65535;
var TextInputStore = /** @class */ (function (_super) {
    __extends(TextInputStore, _super);
    function TextInputStore(props) {
        var _this = _super.call(this, props) || this;
        _this.component = text_input_1.default;
        _this.handleChange = function (event) {
            _this.value = event.target.value;
        };
        _this.maxLength = props.maxLength || DEFAULT_MAX_LENGTH;
        _this.placeholder = props.placeholder || '';
        return _this;
    }
    Object.defineProperty(TextInputStore.prototype, "inputClassNames", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-TextInput_Input', {
                'estimateForm-TextInput_Input-valid': this.valid
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TextInputStore.prototype, "inputClassNames", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TextInputStore.prototype, "handleChange", void 0);
    return TextInputStore;
}(abstract_input_store_1.default));
exports.default = TextInputStore;
